import { AgreementFormEnum, EscrowPartyTypeEnum } from 'src/graphql/schema';
import { RepresentativesContainer, withApiSubmitActions } from 'src/containers/Escrow/Representatives';

import { DepositorOrganization } from '.';

import { DepositorContextProvider, useDepositorContext } from '../model';

const Representatives = withApiSubmitActions(RepresentativesContainer, () => {
  const { depositor, escrowId, agreementType } = useDepositorContext();

  return {
    role: EscrowPartyTypeEnum.Depositor,
    escrowId,
    escrowPartyId: depositor.id,
    contacts: depositor.contacts,
    canUpdate: depositor.policy.update,
    agreementType,
  };
});

type Props = {
  depositorId: string;
  escrowId: string;
  agreementType: AgreementFormEnum;
};

const EscrowDepositorContainer = ({ depositorId, escrowId, agreementType }: Props) => {
  return (
    <DepositorContextProvider depositorId={depositorId} escrowId={escrowId} agreementType={agreementType}>
      <DepositorOrganization />
      <Representatives />
    </DepositorContextProvider>
  );
};

export default EscrowDepositorContainer;
